<template>
  <div>
    <div class="link-warp">
      <div class="link-item active">我的域名</div>
      <div v-if='serverUpdate' class="serverUpdate">
        <div class="tips-warn flx-row-bw-c">
          <div class="left">
             <img class="icon" src="@/assets/image/tips-warn.png" />
             <span>有1家{{ serverUpdate.type === 1 ? '注册局' :'站点'}}计划进行例行维护，请留意维护时间。如有不便，敬请谅解。</span>
          </div>
          <div class="check-detail" @click="showServerUpdate = true">
            查看详情
          </div>
        </div>
      </div>
    </div>
    <div class="condition-section">
      <div class="con-row">
        <div class="item">域名状态：</div>
        <div
          :class="['item', { active: item.value === searchObj.domainStatus }]"
          v-for="item in domainStatusList"
          :key="item.value"
          @click="onCheckDomainStatus(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="cond-row">
        <div class="item" style="margin-right: 30px">
          <div style="margin-right: 10px">域名包含：</div>
          <Input
            class="height45"
            v-model="searchObj.name"
            placeholder="开始长度"
            style="width: 300px"
            clearable
          />
          <CheckboxGroup
            class="height45"
            v-model="searchObj.rule"
            style="margin-left: 20px"
          >
            <Checkbox :label="0"> 开头</Checkbox>
            <Checkbox :label="1"> 结尾</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="item">
          <div style="margin-right: 10px">实名认证：</div>
          <Select
            class="height45"
            v-model="searchObj.approvedStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in approvedStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-right: 70px">
          <div style="margin-right: 10px">注册 / 转入时间：</div>
          <DatePicker
            class="height45"
            :value="registeredAtArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 240px"
            @on-change="onRegisteredChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-right: 60px">
          <div style="margin-right: 10px">过期时间：</div>
          <DatePicker
            class="height45"
            :value="expiredStartTimeArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 240px"
            @on-change="onExpiredTimeChange"
          ></DatePicker>
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
          >
            搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel"> 重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <Table
        class="domain-table"
        ref="domianTable"
        :loading="tableLoading"
        :columns="columns"
        :data="data"
        @on-selection-change="goodsSelectFn"
        @on-select-cancel="selectCancel"
      >
        <template slot="action" slot-scope="{ row }">
          <div v-if="row">
            <Button
              style="margin-right: 5px"
              :disabled="row.domainStatus === 5 || row.domainStatus === 6"
              @click="onToolClick(row, 0)"
              >续费</Button
            >
            <Button
              style="margin-right: 5px"
              :disabled="row.domainStatus === 5 || row.domainStatus === 6"
              @click="onToolClick(row, 1)"
              >解析</Button
            >
            <Button
              style="margin-right: 5px"
              :disabled="row.domainStatus === 5 || row.domainStatus === 6"
              @click="onToolClick(row, 2)"
              >DNS</Button
            >
            <Dropdown
              placement="bottom"
              :transfer="true"
              @on-click="($event) => dropdownEvent($event, row)"
            >
              <Button>更多</Button>
              <DropdownMenu slot="list">
                <DropdownItem
                  :disabled="
                    row.domainStatus === 5 ||
                    row.domainStatus === 6 ||
                    row.bargainStatus !== 0
                  "
                  :name="3"
                  >PUSH</DropdownItem
                >
                <DropdownItem
                  :disabled="
                    row.domainStatus === 5 ||
                    row.domainStatus === 6 ||
                    row.bargainStatus !== 0
                  "
                  :name="4"
                  >模板过户</DropdownItem
                >
                <DropdownItem :name="6">域名详情</DropdownItem>
                <DropdownItem v-if="row.domainStatus === 5" :name="7"
                  >赎回</DropdownItem
                >
                <DropdownItem
                  v-if="row.domainStatus === 6"
                  :disabled="row.domainStatus === 5 || row.domainStatus === 6"
                  :name="8"
                  >赎回中</DropdownItem
                >
                <DropdownItem
                  v-if="
                    row.domainStatus !== 2 &&
                    row.domainStatus !== 5 &&
                    row.domainStatus !== 6 &&
                    row.isAutoRenew === 0
                  "
                  :name="9"
                  >设置自动续费</DropdownItem
                >
                <DropdownItem v-if="row.isAutoRenew === 1" :name="10"
                  >取消自动续费</DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
        <template slot="isExternal" slot-scope="{ row }">
          {{ row.isExternal === 0 ? "智绘网络" : "外部" }}
        </template>
        <template slot="approvedStatus" slot-scope="{ row }">
          {{ row.approvedStatus | approvedStatus }}
        </template>
      </Table>
      <div class="page-tool">
        <div style="margin-right: 100px">
          <Button class="tab-btn" @click="handleSelectAll">{{
            !selectAll ? "全选" : "取消全选"
          }}</Button>
          <Select
            v-model="actionId"
            style="width: 200px; margin-right: 30px; margin-left: 30px"
            @on-change="batchChange"
          >
            <Option
              v-for="item in actionList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
          <Button style="margin-right: 30px" type="primary" @click="batchEvent"
            >批量管理</Button
          >
        </div>
        <Page
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          @on-change="onPageChange"
          show-total
        />
      </div>
    </div>
    <templateListModal
      :show.sync="templateListModalVisibility"
      @onChecked="checkedTemplate"
    ></templateListModal>
    <renewListModal
      :show.sync="renewModalVisibility"
      :title="renewModalTitle"
      :data="renewList"
    ></renewListModal>
    <DNSListModal
      :show.sync="DNSListModalVisibility"
      :data="DNSData"
      @submit-success="onSuccess"
    ></DNSListModal>
    <domainDetailModal
      :show.sync="domainDetailModalVisibility"
      :data="domainDetailData"
    ></domainDetailModal>
    <autoRenewModal
      :show.sync="autoRenewModalVisibility"
      @confirm="autoRenewcConfirm"
    ></autoRenewModal>
    <!-- 例行维护公告 -->
    <Modal
      v-model="showServerUpdate"
      sticky
      :width="650"
      footer-hide
      title="例行维护公告"
    >
      <div v-if='serverUpdate' class="serverUpdate-wrap">
        <div class="serverUpdate-content">{{ serverUpdate.content }}</div>
        <div class="serverUpdate-info">
          <div class="serverUpdate-time">{{ serverUpdate.startTime }} - {{ serverUpdate.endTime }}</div>
          <div class="serverUpdate-item">维护机构：{{ serverUpdate.type === 1 ? 'CNNIC网关' :'站点'}}</div>
          <div class="serverUpdate-item">维护时间：{{ serverUpdate.startTime }} - {{ serverUpdate.endTime }}</div>
          <div class="serverUpdate-item" v-if='serverUpdate.type === 1'>影响域名：<span v-for="(item,index) in serverUpdate.suffix" :key="item">{{ item }}{{index === serverUpdate.suffix.length-1 ? '' : '/'}}</span></div>
          <div class="serverUpdate-item">影响操作：新注、续费、转入、赎回、实名认证等服务</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import {
  domainList,
  addShopCart,
  domainSetPrivacy,
  domainAutoRenew,
  serverUpdate
} from "api/domain.js";
import templateListModal from "components/template/templateListModal.vue";
import renewListModal from "components/domain/renewListModal.vue";
import DNSListModal from "components/domain/DNSListModal.vue";
import domainDetailModal from "components/domain/domainDetailModal.vue";
import autoRenewModal from "components/domain/autoRenewModal.vue";

export default {
  name: "domain",
  filters: {
    approvedStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未认证";
          break;
        case 1:
          title = "认证中(审核中)";
          break;
        case 2:
          title = "认证成功(审核通过)";
          break;
        case 3:
          title = "认证失败(审核未通过)";
          break;
      }
      return title;
    },
  },
  components: {
    templateListModal,
    renewListModal,
    DNSListModal,
    domainDetailModal,
    autoRenewModal,
  },
  data() {
    return {
      tableLoading: false,
      searchObj: {
        domainStatus: -1,
        bargainStatus: -1,
        approvedStatus: -1,
        // 域名品类(一级)
        domainType: "",
        // 域名构成(二级)
        domainConstruction: "",
        // 自动续费
        isAutoRenew: "",
        // 域名后缀
        domainSuffix: "",
        // 注册/转入结束时间
        endedTime: "",
        // 注册/转入开始时间
        registeredAt: "",
        // 过期时间
        expiredStartTime: "",
        expiredEndTime: "",
        // 域名长度
        startExtent: "",
        endExtent: "",
        name: "",
        rule: [],
        page: 1,
        limit: 10,
        total: 0,
      },
      // 域名状态
      domainStatusList: [
        {
          name: "全部域名",
          value: -1,
        },
        {
          name: "30天内到期",
          value: 0,
        },
        {
          name: "已过期",
          value: 1,
        },
        {
          name: "赎回期",
          value: 2,
        },
      ],
      // 交易状态
      bargainStatusList: [
        {
          name: "正在出售",
          value: 0,
        },
        {
          name: "正在push",
          value: 1,
        },
        {
          name: "正在交易",
          value: 2,
        },
        {
          name: "正在转出",
          value: 3,
        },
      ],
      // 实名认证
      approvedStatusList: [
        {
          name: "未认证",
          value: 0,
        },
        {
          name: "认证中(审核中)",
          value: 1,
        },
        {
          name: "认证成功(审核通过)",
          value: 2,
        },
        {
          name: "认证失败(审核未通过)",
          value: 3,
        },
      ],
      domainTypeStr: [],
      isAutoRenewList: [
        {
          name: "否",
          value: 0,
        },
        {
          name: "是",
          value: 1,
        },
      ],
      // 转入时间
      registeredAtArr: [],
      expiredStartTimeArr: [],
      // 全选
      all: false,
      //表格数据
      columns: [
        {
          type: "selection",
          title: "全选",
          width: 50,
          align: "center",
        },
        {
          type: "index",
          title: "序号",
          width: 60,
          align: "center",
        },
        {
          minWidth: 90,
          key: "name",
          title: "域名",
          align: "center",
        },
        {
          minWidth: 85,
          key: "registeredAt",
          title: "注册时间",
          align: "center",
        },
        {
          minWidth: 85,
          key: "expiredAt",
          title: "过期时间",
          align: "center",
        },
        {
          minWidth: 85,
          slot: "isExternal",
          title: "注册商",
          align: "center",
        },
        {
          minWidth: 80,
          key: "templateName",
          title: "模板",
          align: "center",
        },
        {
          minWidth: 100,
          slot: "approvedStatus",
          title: "实名认证",
          align: "center",
        },
        {
          width: 300,
          slot: "action",
          title: "操作",
          align: "center",
        },
      ],
      data: [],
      actionId: null,
      // 操作选项
      actionList: [
        {
          value: 1,
          label: "批量续费",
        },
        {
          value: 2,
          label: "设置自动续费",
        },
        {
          value: 3,
          label: "取消自动续费",
        },
        // {
        //   value: 4,
        //   label: "设置DNS",
        // },
        {
          value: 5,
          label: "开启隐私保护",
        },
        {
          value: 6,
          label: "关闭隐私保护",
        },
        // {
        //   value: 7,
        //   label: "批量出售",
        // },
        {
          value: 8,
          label: "批量PUSH",
        },
      ],
      templateListModalVisibility: false, // 选择模板
      templateInfo: {},
      renewModalVisibility: false, // 续费
      renewList: [],
      renewModalTitle: "",
      checkedDomain: [],
      value: [],
      selectAll: false,
      DNSListModalVisibility: false, // DNS
      DNSData: {},
      domainDetailModalVisibility: false, // 域名详情
      domainDetailData: {},
      autoRenewModalVisibility: false, // 续费弹窗
      serverUpdate:null,
      showServerUpdate:false
    };
  },
  computed: {
    ...mapState(["domainQueryData"]),
  },
  watch: {
    checkedDomain: {
      immediate: true,
      handler(val) {
        this.value = val;
      },
    },
  },
  created() {
    if (
      this.domainQueryData.domainTypeList.length === 0 ||
      this.domainQueryData.domainSufNameList.length === 0
    ) {
      this.ACT_DOMAIN_QUERY();
    }
    this.getServerUpdate();
    this.req_getList();
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    ...mapMutations(["MTU_ROUTE_PARAMS_LIST"]),
     // 获取例行维护公告 
    async getServerUpdate() {
      const { code, data } = await serverUpdate();
      if (code == 200) {
        this.serverUpdate = data
      }
    },
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.searchObj.domainStatus !== -1 &&
          (params.expiredStatus = this.searchObj.domainStatus);
        this.searchObj.bargainStatus !== -1 &&
          (params.bargainStatus = this.searchObj.bargainStatus);
        this.searchObj.approvedStatus !== -1 &&
          (params.approvedStatus = this.searchObj.approvedStatus);
        this.searchObj.domainType &&
          (params.domainType = this.searchObj.domainType);
        this.searchObj.domainConstruction &&
          (params.domainConstruction = this.searchObj.domainConstruction);
        this.searchObj.isAutoRenew &&
          (params.isAutoRenew = this.searchObj.isAutoRenew);
        this.searchObj.domainSuffix &&
          (params.domainSuffix = this.searchObj.domainSuffix);
        this.searchObj.registeredAt &&
          (params.registeredAt = this.searchObj.registeredAt);
        this.searchObj.endedTime &&
          (params.endedTime = this.searchObj.endedTime);
        this.searchObj.expiredStartTime &&
          (params.expiredStartTime = this.searchObj.expiredStartTime);
        this.searchObj.expiredEndTime &&
          (params.expiredEndTime = this.searchObj.expiredEndTime);
        this.searchObj.startExtent &&
          (params.startExtent = this.searchObj.startExtent);
        this.searchObj.endExtent &&
          (params.endExtent = this.searchObj.endExtent);
        this.searchObj.name && (params.name = this.searchObj.name);
        this.searchObj.rule.length > 0 &&
          (params.rule = this.searchObj.rule[0]);
        this.templateInfo.templateId &&
          (params.TId = this.templateInfo.templateId);
        this.tableLoading = true;
        const { code, data } = await domainList(params);
        this.tableLoading = false;
        if (code === 200) {
          let array = data.list.map((o) => {
            let isCheckEd = false;
            if (this.checkedDomain.length > 0) {
              isCheckEd = this.checkedDomain.some((v) => {
                return v === o.name;
              });
            }
            return { ...o, _checked: isCheckEd, _disabled: false };
          });
          this.data = array;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 域名转台改变
    onCheckDomainStatus(val) {
      this.searchObj.domainStatus = val;
      this.onPageChange(1);
    },
    // 日期改变
    onRegisteredChange(event) {
      this.searchObj.registeredAt = event[0];
      this.searchObj.endedTime = event[1];
    },
    // 日期改变
    onExpiredTimeChange(event) {
      this.searchObj.expiredStartTime = event[0];
      this.searchObj.expiredEndTime = event[1];
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.templateInfo = {};
      this.onPageChange(1);
    },
    // 分页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    //全选
    handleSelectAll() {
      if (!this.actionId) {
        this.$Message.warning("请先选择批量操作类型！");
        return false;
      }
      this.selectAll =
        this.data.filter((o) => !o._disabled).length !==
        this.data.filter((o) => o._checked).length;
      // 设置选中状态
      this.$nextTick(() => {
        this.data.forEach((o) => {
          o._checked = this.selectAll;
        });
        this.$refs.domianTable.selectAll(this.selectAll);
      });
    },
    // 批量类型事件
    batchChange(value) {
      this.data.forEach((o) => {
        let _disabled = false;
        if (value === 1 || value === 4 || value === 7 || value === 8) {
          // 批量续费  设置DNS 批量出售 批量PUSH // schedule域名状态  isAutoRenew是否自动续费  certificationStatus认证状态 isShowUser隐私保护
          o._disabled = o.domainStatus === 5 || o.domainStatus === 6;
          value === 7 && o.approvedStatus !== 2 && (o._disabled = true);
          value === 8 && o.bargainStatus !== 0 && (o._disabled = true);
        } else if (value === 2) {
          // 自动续费
          o._disabled =
            o.domainStatus === 2 ||
            o.domainStatus === 5 ||
            o.domainStatus === 6 ||
            o.isAutoRenew === 1;
        } else if (value === 2) {
          // 取消自动续费
          o._disabled = o.isAutoRenew !== 1;
        } else if (value === 5) {
          // 设置隐私保护
          o._disabled = o.isHideUserinfo === 0;
        } else if (value === 6) {
          // 取消隐私保护
          o._disabled = o.isHideUserinfo === 1;
        }
        if (this.selectAll) {
          o._checked = !o._disabled;
        }
        return { ...o, _disabled };
      });
      if (this.selectAll) {
        this.value = this.data
          .filter((o) => o._checked)
          .map((o) => {
            return { name: o.name, did: o.did };
          });
        this.value.length === 0 && (this.selectAll = false);
      }
    },
    goodsSelectFn(item) {
      if (item.length > 0) {
        let obj = {};
        item.forEach((o) => {
          !o._disabled && (obj[o.did] = true);
        });
        // 设置选中状态
        this.data.forEach((o) => {
          if (obj[o.did]) {
            o._checked = true;
          } else {
            o._checked = false;
          }
        });
        // 组合所有数据
        obj = {};
        let newArray = [
          ...this.value,
          ...(this.data.filter((o) => o._checked) || []),
        ];
        // 取数据的并集
        this.value = newArray.reduce((item, next) => {
          if (!obj[next.did]) {
            obj[next.did] = true;
            item.push({ ...next, _checked: true });
          }
          return item;
        }, []);
      } else {
        let obj = {};
        // 排除取消选中的数据
        this.data.forEach((o) => {
          !o._disabled && (obj[o.did] = true);
        });
        this.value = this.value.reduce((item, next) => {
          !obj[next.did] && item.push({ ...next, _checked: true });
          return item;
        }, []);
      }
    },
    selectCancel(selection, row) {
      let index = this.value.findIndex((item) => {
        return item.did === row.did;
      });
      this.value.splice(index, 1);
    },
    // 更多操作
    dropdownEvent(type, data) {
      if (type === 3) {
        // PUSH
        if (data.bargainStatus !== 0) {
          let title = "";
          switch (data.bargainStatus) {
            case 1:
              title = "域名正在出售中!";
              break;
            case 2:
              title = "域名正在PUSH中!";
              break;
            case 3:
              title = "域名正在转出中!";
              break;
            case 4:
              title = "域名正在预删除中!";
              break;
          }
          this.$Message.warning(title);
          return false;
        }
        // 传递参数
        this.MTU_ROUTE_PARAMS_LIST([data.name]);
        this.$router.push({
          path: "/user/push",
        });
      } else if (type === 4) {
        // 模板过户
        if (data.bargainStatus !== 0) {
          let title = "";
          switch (data.bargainStatus) {
            case 1:
              title = "域名正在出售中!";
              break;
            case 2:
              title = "域名正在PUSH中!";
              break;
            case 3:
              title = "域名正在转出中!";
              break;
            case 4:
              title = "域名正在预删除中!";
              break;
          }
          this.$Message.warning(title);
          return false;
        }
        // 传递参数
        this.MTU_ROUTE_PARAMS_LIST([data.name]);
        this.$router.push({
          path: "/user/template/transfer",
        });
      } else if (type === 6) {
        // 域名详情
        this.domainDetailModalVisibility = true;
        this.domainDetailData = data;
      } else if (type === 9 || type === 10) {
        // 设置自动续费 OR 取消自动续费
        this.autoRenewType = type === 9 ? 0 : 1;
        this.autoRenewIds = [data.name];
        this.autoRenewModalVisibility = true;
      }
    },
    // 续费
    async req_renew(val) {
      try {
        let params = {
          goodsNames: val,
          goodsType: 1,
        };
        const { code, data, result } = await addShopCart(params);
        if (code === 200 && result && data.length === 0) {
          this.$Message.success("添加成功！");
          setTimeout(() => {
            window.location.href = "/cart";
          }, 1000);
        } else {
          this.renewModalVisibility = true;
          this.renewModalTitle = "域名续费结果";
          this.renewList = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 操作按钮事件
    onToolClick(val, type = 0) {
      if (type === 0 && val.domainStatus !== 5 && val.domainStatus !== 6) {
        // 续费
        this.req_renew([val.name]);
      } else if (
        type === 1 &&
        val.domainStatus !== 5 &&
        val.domainStatus !== 6
      ) {
        // 解析
        if (val.dnsPlatform === 1) {
          this.$Message.warning("第三方DNS，禁止在本平台解析!");
          return false;
        }
        this.$router.push({
          name: `domainAnalysis`,
          query: {
            id: val.did,
            domainName: val.name,
          },
        });
      } else if (
        type === 2 &&
        val.domainStatus !== 5 &&
        val.domainStatus !== 6
      ) {
        // DNS
        this.DNSListModalVisibility = true;
        this.DNSData = val;
      }
    },
    // 点击批量操作
    batchEvent() {
      if (!this.actionId) {
        this.$Message.warning("请选择操作类型!");
        return false;
      }
      if (this.value.length <= 0) {
        this.$Message.warning("请选择要操作的数据!");
        return false;
      }

      if (this.actionId === 1) {
        //批量续费
        this.req_renew(
          this.value.map((o) => {
            return o.name;
          })
        );
      } else if (this.actionId === 8) {
        //批量PUSH
        // 传递参数
        this.MTU_ROUTE_PARAMS_LIST(
          this.value.map((o) => {
            return o.name;
          })
        );
        this.$router.push({
          path: "/user/push",
        });
      } else if (this.actionId === 5 || this.actionId === 6) {
        this.privacyIds = this.value.map((o) => {
          return o.did;
        });
        this.$Modal.confirm({
          title: `${this.actionId === 5 ? "开启隐私保护" : "关闭隐私保护"}`,
          content: `${
            this.actionId === 5 ? "是否开启隐私保护?" : "是否关闭隐私保护?"
          }`,
          onOk: async () => {
            try {
              const { code, data } = await domainSetPrivacy({
                domainIdList: this.privacyIds,
                isHidden: this.actionId === 5 ? 0 : 1,
              });
              if (code === 200) {
                if (data.length === 0) {
                  this.$Message.success("操作成功！");
                } else {
                  this.renewModalTitle =
                    this.actionId === 5
                      ? "开启隐私保护结果"
                      : "关闭隐私保护结果";
                  this.renewModalVisibility = true;
                  this.renewList = data.map((o) => {
                    return {
                      domainName: o.name,
                      message: o.reason,
                      status: o.status,
                    };
                  });
                }
              }
              this.req_getList();
            } catch (error) {
              console.log(error);
            }
          },
        });
      } else if (this.actionId === 2 || this.actionId === 3) {
        this.autoRenewType = this.actionId === 2 ? 0 : 1;
        this.autoRenewIds = this.value.map((o) => {
          return o.did;
        });
        this.autoRenewModalVisibility = true;
      }
      // else if (this.batchValue === 21 || this.batchValue === 22) {
      //   //设置自动续费
      //   this.domainIdList = selectList.map((o) => {
      //     return o.domainId;
      //   });
      //   this.autoRenewType = this.batchValue === 21 ? 0 : 1;
      //   // 打开短信验证码模态框
      //   this.autoRenewModalShow = true;
      //   // this.batchAutoRenew(data, 0);
      // } else if (this.batchValue === 23) {
      //   // 批量设置DNS
      //   this.settingsDNSModalShow = true;
      //   this.domainIds = selectList.map((o) => {
      //     return o.id;
      //   });
      // } else if (this.batchValue === 24 || this.batchValue === 25) {
      //   this.privacyIds = selectList.map((o) => {
      //     return o.id;
      //   });
      //   this.$Modal.confirm({
      //     title: `${this.batchValue === 24 ? '开启隐私保护' : '关闭隐私保护'}`,
      //     content: `${this.batchValue === 24 ? '是否开启隐私保护?' : '是否关闭隐私保护?'}`,
      //     onOk: async () => {
      //       const { code, data } = await this.$API.bidding.setPrivacy({
      //         domainIds: this.privacyIds,
      //         isHide: this.batchValue === 24 ? 0 : 1
      //       });
      //       if (code === 200) {
      //         if (data.length === 0) {
      //           this.$Message.success('操作成功！');
      //         } else {
      //           this.autoRenewModalTitle = this.batchValue === 24 ? '开启隐私保护结果' : '关闭隐私保护结果';
      //           this.autoRenewModalShow = true;
      //           this.autoRenewrenewList = data;
      //         }
      //       }
      //       this.getDomainPageList();
      //     }
      //   });
      // } else if (this.batchValue === 26) {
      //   const data = selectList.map((o) => {
      //     return o.domainName;
      //   });
      //   this.$router.push({
      //     name: 'user-dnSell',
      //     params: { dnList: data }
      //   });
      // } else if (this.batchValue === 27) {
      //   const data = value.map((o) => {
      //     return o.domainName;
      //   });
      //   this.$router.push({
      //     name: 'user-dnPush',
      //     params: { dnList: data }
      //   });
      // }
      // this.$emit('batchEvent', this.batchValue, selectList);
    },
    async autoRenewcConfirm(val, callback) {
      try {
        this.tableLoading = true;
        const res = await domainAutoRenew({
          code: val,
          domainIds: this.autoRenewIds,
          type: this.autoRenewType,
        });
        if (res.code === 200) {
          if (res.data.length === 0) {
            this.$Message.success("操作成功！");
          } else {
            // this.autoRenewModalTitle = this.autoRenewType === 0 ? '设置自动续费结果' : '取消设置自动续费结果';
            // this.autoRenewModalShow = true;
            // this.autoRenewrenewList = res.data;
            this.renewModalVisibility = true;
            this.renewModalTitle =
              this.autoRenewType === 0
                ? "设置自动续费结果"
                : "取消设置自动续费结果";
            this.renewList = res.data;
          }
        }
        this.autoRenewModalVisibility = false;
        callback(true);
        this.req_getList();
        this.tableLoading = false;
      } catch (error) {
        this.tableLoading = false;
        callback(true);
        console.log(error);
      }
    },
    onSuccess(callback) {
      this.req_getList();
      callback(true);
    },
  },
};
</script>
<style lang="less" scoped>
.link-warp {
  position: relative;
  background-color: #fff;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
  .tips-warn {
    padding: 15px 30px;
    border-radius: 8px;
    color: #333333;
    font-size: 14px;
    background-color: #e9effd;
    border: 1px solid #3992e9;
    display: flex;
    align-items: center;
    .left{
      display: flex;
      align-items: center;
    }
    .icon {
      margin-right: 10px;
      width: 20px;
      height: 19px;
    }
    .check-detail{
			width:100px;
			background:#2d8cf0;
			text-align: center;
			color: #fff;
			height: 30px;
			line-height: 30px;
			border-radius: 5px;
			cursor: pointer;
      margin-left: 20px;
	  }
  }
}

.title {
  font-size: 20px;
  color: #3992e9;
  font-weight: bold;
  background-color: #fff;
  padding: 0px 60px;
  line-height: 80px;
  height: 80px;
}
.condition-section {
  margin: 40px 60px 0;
  background-color: #fff;
  padding: 20px 50px;
  .con-row {
    display: flex;
    height: 40px;
    line-height: 40px;
    .item {
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      cursor: pointer;
      margin-right: 40px;
    }
    .item.active {
      color: #3992e9;
    }
  }
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.table-data {
  margin: 40px 60px;
  background-color: #fff;
  padding: 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  align-items: center;
}
.serverUpdate-wrap{
  padding: 20px;
  color: #333;
  .serverUpdate-info{
    margin-top: 20px;
    padding-top: 20px;
    border-top:1px solid #e8eaec;
    .serverUpdate-time{
      font-weight: bold;
      margin-bottom: 10px;
      position: relative;
      margin-left: 15px;
      &::before{
        position: absolute;
        top:8px;
        left:-15px;
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #3992E9;
      }
    }
    .serverUpdate-item{
      margin: 5px 0 5px 15px;
    }
  }
}

/deep/.domain-table {
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
  .ivu-table-header {
    th:nth-child(1) {
      text-align: center;
      .ivu-checkbox-inner {
        // border-radius: 50%;
        width: 0px;
        border: none;
        &:after {
          width: 0px;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
